var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 9.00005C18.5001 13.9706 14.4706 18.0001 9.50005 18.0001C4.52946 18.0001 0.5 13.9706 0.5 9.00005C0.5 4.02946 4.52946 0 9.50005 0C14.4706 0 18.5001 4.02946 18.5001 9.00005Z",
    fill: "#FF7663"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42383 4.25C8.83804 4.25 9.17383 4.58579 9.17383 5V13C9.17383 13.4142 8.83804 13.75 8.42383 13.75C8.00961 13.75 7.67383 13.4142 7.67383 13V5C7.67383 4.58579 8.00961 4.25 8.42383 4.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 11.5C6.125 11.0858 6.46079 10.75 6.875 10.75L11.2892 10.75C11.7034 10.75 12.0392 11.0858 12.0392 11.5C12.0392 11.9142 11.7034 12.25 11.2892 12.25L6.875 12.25C6.46079 12.25 6.125 11.9142 6.125 11.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4791 5.06916C11.9854 4.54954 11.3073 4.25 10.5916 4.25H8.49249C8.07828 4.25 7.74249 4.58579 7.74249 5C7.74249 5.41421 8.07828 5.75 8.49249 5.75H10.5916C10.884 5.75 11.1727 5.87189 11.3917 6.10241C11.612 6.33424 11.7421 6.65647 11.7421 7C11.7421 7.34353 11.612 7.66576 11.3917 7.89759C11.1727 8.12811 10.884 8.25 10.5916 8.25H8.49249C8.07828 8.25 7.74249 8.58579 7.74249 9C7.74249 9.41421 8.07828 9.75 8.49249 9.75H10.5916C11.3073 9.75 11.9854 9.45046 12.4791 8.93084C12.9716 8.41252 13.2421 7.71734 13.2421 7C13.2421 6.28266 12.9716 5.58748 12.4791 5.06916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebt);
export default __webpack_public_path__ + "static/media/debt.70bd38018198d3e8c55cafe5d738d67c.svg";
export { ForwardRef as ReactComponent };